import { z } from 'zod';

import { AssistantToolType as AssistantToolTypeEnum } from '../toolDefinition/index.js';

const AssistantToolTypeServerSchema = z.object({
  path: z.string(),
});

export const AssistantToolTypeSchema = z.object({
  name: z.string(),
  type: z.nativeEnum(AssistantToolTypeEnum),
  description: z.string().nullable().optional(),
  parameters: z.record(z.string(), z.unknown()).nullable().optional(),
  startMessage: z.string().nullable().optional(),
  failedMessage: z.string().nullable().optional(),
  delayedMessage: z.string().nullable().optional(),
  delayThresholdMilliseconds: z.number().nullable().optional(),
  completeMessage: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
  endCallAfterCompleteMessageSpoken: z.boolean().nullable().optional(),
  endCallAfterFailedMessageSpoken: z.boolean().nullable().optional(),
  async: z.boolean().optional(),
  warning: z.string().nullable().optional(),
  group: z.string().nullable().optional(),
  smallDescription: z.string().optional(),
  server: AssistantToolTypeServerSchema.optional(),
  strict: z.boolean().optional(),
  timeoutSeconds: z.number().nullable().optional(),
});

export type AssistantToolType = z.infer<typeof AssistantToolTypeSchema>;
